import {
  SELECT_CURRENCY_FAILURE,
  SELECT_CURRENCY_REQUESTED,
  SELECT_CURRENCY_SUCCESS,
} from 'actiontypes/payment';
import PaymentService from 'services/PaymentService';
import { IBraintreeNexOptionsResponse } from 'types/payment';

const paymentService = new PaymentService();

/** ----------------------------------------------------------------------------
 * SELECT CURRENCY
 -----------------------------------------------------------------------------*/
export default function selectCurrency(currencyCode: string) {
  return async (dispatch: Function) => {
    dispatch(selectCurrencyRequested(currencyCode));

    try {
      const { data } = await paymentService.selectCurrency(currencyCode);
      dispatch(selectCurrencySuccess(data, currencyCode));
      return data;
    } catch (error) {
      dispatch(selectCurrencyFailure(error));
    }
  };
}

export const selectCurrencyRequested = (currencyCode: string) => ({
  type: SELECT_CURRENCY_REQUESTED,
  payload: { currency: currencyCode },
});

export const selectCurrencySuccess = (data: IBraintreeNexOptionsResponse, currencyCode: string) => ({
  type: SELECT_CURRENCY_SUCCESS,
  payload: { ...data, currency: currencyCode },
});

export const selectCurrencyFailure = (error: any) => ({
  type: SELECT_CURRENCY_FAILURE,
  payload: { error: true, status: error.response && error.response.status },
});
